import barba from '@barba/core';
import { clock } from './import/clock';
import { playButton, audioPlayer } from './import/player';
import { homeArchiveScrollover, homeScroll, updateHomeScrollInfo } from './import/home';
import { gallery } from './import/gallery';
import { expandable } from './import/expandable';
import { menu } from './import/menu';
import { marquee } from './import/marquee';
import { scrollStatus } from './import/scrollStatus';
import { references } from './import/references';
import { rollInImage } from './import/rollInImage';
import { hoverJiggleAnimate } from './import/hoverJiggleAnimate';
import { initDraggable } from './import/draggable';
import { projectFeatureHover } from './import/projectFeatureHoverImage';

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}

const siteMarquee = marquee(document.querySelector('.marquee'), {speed: 50});
const player = audioPlayer(document.querySelector('.player'), {marquee: siteMarquee});
runOnce();

barba.init({
  timeout: 5000,
  views: [
    {
      namespace: 'home',
      afterEnter(data) {
        console.log('afterEnter home');
        window.addEventListener('resize', updateHomeScrollInfo);
        window.addEventListener('scroll', homeScroll, false);
        runAll();
        runHome();
      },
      beforeLeave(data) {
        window.removeEventListener('resize', updateHomeScrollInfo);
        window.removeEventListener('scroll', homeScroll, false);
      },
    },
    {
      namespace: 'projects',
      afterEnter(data) {
        console.log('afterEnter projects');
        runAll();
        runProjects();
      }
    },
    {
    namespace: 'project',
    afterEnter(data) {
      console.log('afterEnter project');
      runAll();
      runProject();
    },
    },
  ],
});

barba.hooks.enter(function(data) {
  console.log('enter hook, remove container');
  data.current.container.remove();
});

barba.hooks.beforeEnter(function(data) {
  console.log('beforeEnter hook, scrollTo');
  if (!data.next.url.hash) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }
});

barba.hooks.afterEnter(function(data) {
  console.log('afterEnter hook, scrollTo');
  if (data.next.url.hash) {
    const target = document.body.querySelector('#' + data.next.url.hash);

    if (target) {
      console.log('target');
      window.scrollTo({
        top: 99999, 
        left: 0,
        behavior: 'instant',
      });

      setTimeout(function() {
        target.scrollIntoView({
          behavior: 'instant',
          block: 'center',
        });
      }, 10);
    } else {
      console.log('invalid anchor');
      window.scrollTo({
        top: 0, 
        left: 0,
        behavior: 'instant',
      });
    }
  }
});

function runOnce() {
  clock(document.querySelector('.clock'));
  menu(document.querySelector('.menu'));
  scrollStatus();
  document.querySelectorAll('.logo-overlay').forEach(function(el) {
    el.addEventListener('click', hideLogoOverlay);
    el.addEventListener('wheel', hideLogoOverlay);
    function hideLogoOverlay() {
      el.classList.add('inactive');
    }
  });
  document.body.querySelectorAll('.clock, .logo-overlay .logo, .menu__button, .menu__wrapper > a').forEach(function(el) {
    hoverJiggleAnimate(el);
  });
  document.body.querySelectorAll('.player__stream-link').forEach(function(el) {
    // Play live
    playButton(el, player);
  });
}

function runAll() {
  initPlayButtons();
  player.updatePlayButtons(undefined, true);
  document.body.querySelectorAll('.project-feature, .entry-header').forEach(function(el) {
    rollInImage(el);
  });
  document.body.querySelectorAll('.play-audio, .map-block__button, .save-date').forEach(function(el) {
    hoverJiggleAnimate(el);
  });
  document.body.classList.remove('above-fold');
}

function runHome() {
  updateHomeScrollInfo();
  homeScroll();

  setTimeout(function(){
    updateHomeScrollInfo();
    homeScroll();
  }, 100);

  document.querySelectorAll('.draggable').forEach(function(el) {
    initDraggable(el);
  });

  document.body.querySelectorAll('.project-upcoming').forEach(function(el) {
    projectFeatureHover(el, '.project-feature__title');
  });
}

function runProjects() {

}

function runProject(content = document.body) {
  content.querySelectorAll('.gallery--slide').forEach(function(el) {
    gallery(el);
  });
  content.querySelectorAll('.map-block').forEach(function(el) {
    expandable(el, {selector: '.map-block'});
  });
  content.querySelectorAll('.image-block').forEach(function(el) {
    expandable(el, {selector: '.image-block'});
  });
  references({referenceLinkSelector: '.numbered-reference',});
  document.body.querySelectorAll('.entry-header').forEach(function(el) {
    projectFeatureHover(el, '.entry-header__title');
  });
}

function initPlayButtons(content = document.body) {
  const playButtons = content.querySelectorAll('.play-audio');
  playButtons.forEach(function(el) {
    playButton(el, player, false);
  });
}
